import { useTheme } from '@mui/material';

import { Icons, ExternalLink, Typography } from '@cast/design-system';

import { CloseableAlert } from 'components/alerts';

import { getDocsLink } from '@cast/utils';

export const FailedToDrainNodesAlert = () => {
  const { palette } = useTheme();

  return (
    <CloseableAlert
      title="Cluster costs have increased due to problematic nodes"
      color="advisory"
      size="small"
      icon={<Icons.Warning color={palette.red[500]} />}
      closeable={false}
      testId="failed-to-drain-nodes-alert"
    >
      <Typography variant="P12R">
        Your action is required to clean up nodes that failed to drain during
        rebalancing.{' '}
        <ExternalLink
          sx={{ typography: 'P12M' }}
          link={getDocsLink('docs_rebalancing_handling_failed_node_drains')}
        >
          Learn more
        </ExternalLink>
      </Typography>
    </CloseableAlert>
  );
};
